<template>
  <div class="mb-4">
    <div class="title mb-3 blue--text text--darken-4 font-weight-bold">
      {{ options.title }}
    </div>
    <slot v-if="$slots.default" />
    <template v-else-if="$scopedSlots.items">
      <slot
        name="items"
        :items="options.items"
      />
    </template>
    <template v-else-if="$scopedSlots.item">
      <slot
        v-for="(item) in options.items"
        name="item"
        :item="item"
      />
    </template>
    <template v-else>
      <sidebar-section-item
        v-for="(item, index) in options.items"
        :key="index"
        :item="item"
      />
    </template>
  </div>
</template>

<script>
import SidebarSectionItem from '@/views/dark-template/sidebar/SectionItem'
export default {
  name      : 'SidebarSection',
  components: { SidebarSectionItem },
  props     : { options: { type: Object, default: () => {} } },
}
</script>

<style scoped>
.title {
  border-bottom: 2px #d32f2f solid; /* Updated to your specific Red */
  font-weight: 500;
  line-height: 1.5 !important;
  letter-spacing: 0.1em !important;
}
</style>